import { AuthStep } from 'constants/authStep';
import { DEFAULT_USER } from 'constants/defaultUser';

import { useContext, useEffect, useState } from 'react';

import { APIContext } from 'context/apiContext';
import { useCaptcha } from 'hooks/useCaptcha';
import { AuthLayout } from 'layouts/components/AuthLayout/AuthLayout';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { executeCaptcha } from 'utils';

import { AUTH_STEPS_TITLES } from './constants/authStepsTitles';
import { LoginCredentialsForm } from './LoginCredentialsForm';
import { LoginSecondFactorForm } from './LoginSecondFactorForm';
import { LoginTempPasswordForm } from './LoginTempPasswordForm';

export const Login = (): JSX.Element => {
  const translate = useTypedTranslate();

  const [step, setStep] = useState<AuthStep>(AuthStep.Credentials);
  const { setUser } = useContext(APIContext);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setUser(DEFAULT_USER);
  }, []);

  useCaptcha();

  const updateStep = (step: AuthStep) => setStep(step);
  const componentConfig: Record<AuthStep, JSX.Element> = {
    [AuthStep.Credentials]: (
      <LoginCredentialsForm
        error={error}
        key="credentials"
        setError={setError}
        updateStep={updateStep}
      />
    ),
    [AuthStep.ChangePassword]: (
      <LoginTempPasswordForm
        error={error}
        key="changePassword"
        setError={setError}
        updateStep={updateStep}
      />
    ),
    [AuthStep.SecondFactor]: (
      <LoginSecondFactorForm
        callback={executeCaptcha}
        error={error}
        key="secondFactor"
        setError={setError}
        updateStep={updateStep}
      />
    ),
  };

  return (
    <AuthLayout title={translate(AUTH_STEPS_TITLES[step])}>{componentConfig[step]}</AuthLayout>
  );
};
